export const FETCH_INSURANCE_START = 'FETCH_INSURANCE_START';
export const FETCH_INSURANCE_SUCCESS = 'FETCH_INSURANCE_SUCCESS';
export const FETCH_INSURANCE_FAILURE = 'FETCH_INSURANCE_FAILURE';
